class FsDropdownMenu extends HTMLElement {
  constructor() {
    super()

    this.allowMultiple = this.dataset.allowMultiple === 'true'
    this.elsDetails = Array.from(this.querySelectorAll('details'))
    this.currentIndex = null
    this.mm = gsap.matchMedia()

    this.addEventListeners()
  }

  addEventListeners() {
    this.elsDetails.forEach((elDetails, index) => {
      const elSummary = elDetails.querySelector('summary')
      elSummary.addEventListener('click', (e) => {
        this.mm.add('(prefers-reduced-motion: no-preference)', () => {
          e.preventDefault()
          this.toggleDetails(index)
        })
      })
    })
  }

  async toggleDetails(index) {
    const elDetails = this.elsDetails[index]

    if (!this.allowMultiple && this.currentIndex !== null && this.currentIndex !== index) {
      const elCurrentDetails = this.elsDetails[this.currentIndex]
      this.closeDetails(elCurrentDetails)
    }

    if (elDetails.open) {
      await this.closeDetails(elDetails)
      this.currentIndex = null
    } else {
      this.currentIndex = index
      this.openDetails(elDetails)
    }
  }

  async closeDetails(elDetails) {
    const elContent = elDetails.querySelector('div')
    const elTextContent = elDetails.querySelector('ul')

    const height = elContent.scrollHeight
    await gsap.timeline({ defaults: { duration: 0.3, ease: 'sine.inOut' } })
      .fromTo(elTextContent, { opacity: 1 }, { opacity: 0 })
      .fromTo(elContent, { height }, { height: 0 }, '<')
      .set([elContent, elTextContent], { clearProps: true })
    elDetails.open = false
  }

  openDetails(elDetails) {
    const elContent = elDetails.querySelector('div')
    const elTextContent = elDetails.querySelector('ul')

    elDetails.open = true
    const height = elContent.scrollHeight

    gsap.timeline({ defaults: { duration: 0.3, ease: 'sine.inOut' } })
      .fromTo(elContent, { height: 0 }, { height, ease: 'sine.inOut' })
      .fromTo(elTextContent.children, { opacity: 0 }, { opacity: 1, stagger: 0.05 }, '-=0.3')
      .set([elContent, elTextContent.children], { clearProps: true })
  }
}

if (!customElements.get('fs-dropdown-menu')) {
  customElements.define('fs-dropdown-menu', FsDropdownMenu)
}
